(() => {
  if (window.gtPrivacyInstalled) return;
  window.gtPrivacyInstalled = true;
  let previous = null;
  let apiRequested = false;
  let reloading = false;
  let attempts = 0;
  const groups = ['analytics', 'marketing', 'preferences'];
  const methods = { analytics: 'analyticsProcessingAllowed', marketing: 'marketingAllowed', preferences: 'preferencesProcessingAllowed' };
  const api = () => window.Shopify && window.Shopify.customerPrivacy;
  const permitted = (category) => {
    const privacy = api();
    if (!privacy) return false;
    return privacy.currentVisitorConsent()[category] === 'yes' && privacy[methods[category]]();
  };
  const removeProviderStorage = () => {
    const patterns = [];
    if (!permitted('analytics')) patterns.push(/^ig-/, /^loomi[-_]/, /^visually[-_]/);
    if (!permitted('analytics') || !permitted('marketing')) patterns.push(/^__up_/);
    if (!patterns.length) return;
    try {
      document.cookie.split(';').map(part => part.split('=')[0].trim()).filter(name => patterns.some(pattern => pattern.test(name))).forEach(name => {
        const domains = ['', location.hostname, '.' + location.hostname];
        const parts = location.pathname.split('/');
        const paths = new Set(['/']);
        while (parts.length > 1) { paths.add(parts.join('/') || '/'); parts.pop(); }
        domains.forEach(domain => paths.forEach(path => {
          document.cookie = `${name}=; Max-Age=0; path=${path}${domain ? '; domain=' + domain : ''}; SameSite=Lax; Secure`;
        }));
      });
      [localStorage, sessionStorage].forEach(storage => {
        Object.keys(storage).filter(name => patterns.some(pattern => pattern.test(name))).forEach(name => storage.removeItem(name));
      });
    } catch (_) {}
  };
  const loadService = async (template) => {
    const categories = template.dataset.gtConsent.split(' ');
    if (template.dataset.loaded || !categories.every(permitted)) return;
    template.dataset.loaded = 'true';
    const fragment = template.content.cloneNode(true);
    const scripts = Array.from(fragment.querySelectorAll('script'));
    scripts.forEach(script => script.remove());
    fragment.querySelectorAll('link[rel="preload"],link[rel="preconnect"],link[rel="dns-prefetch"]').forEach(link => link.remove());
    document.body.appendChild(fragment);
    for (const source of scripts) {
      if (reloading || !categories.every(permitted)) return;
      const script = document.createElement('script');
      for (const attribute of source.attributes) {
        if (!['async', 'defer', 'blocking'].includes(attribute.name)) script.setAttribute(attribute.name, attribute.value);
      }
      script.async = false;
      script.textContent = source.textContent;
      script.dataset.gtService = template.dataset.gtService;
      if (source.src) {
        await new Promise(resolve => { script.onload = resolve; script.onerror = resolve; document.head.appendChild(script); });
      } else document.head.appendChild(script);
    }
  };
  const update = (changed = false) => {
    const privacy = api();
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
    const current = Object.fromEntries(groups.map(category => [category, permitted(category)]));
    const revoked = previous && groups.some(category => previous[category] && !current[category]);
    previous = current;
    removeProviderStorage();
    document.dispatchEvent(new CustomEvent('gt:privacy-ready'));
    if (changed && revoked && !reloading) {
      reloading = true;
      setTimeout(() => location.reload(), 100);
      return true;
    }
    document.querySelectorAll('template[data-gt-consent]').forEach(loadService);
    return true;
  };
  document.addEventListener('visitorConsentCollected', () => update(true));
  // Keep the native preferences available after a saved decision, including previews.
  let bannerLoading;
  document.addEventListener('click', async event => {
    const link = event.target.closest && event.target.closest('a[href="#shopifyReshowConsentBanner"]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      if (!window.privacyBanner) {
        if (!bannerLoading) bannerLoading = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload = resolve;
          script.onerror = () => { bannerLoading = null; reject(new Error('Privacy banner unavailable')); };
          document.head.appendChild(script);
        });
        await bannerLoading;
      }
      await window.privacyBanner.showPreferences();
    } catch (_) {
      link.textContent = 'Cookie-Einstellungen konnten nicht geladen werden. Bitte erneut versuchen.';
    }
  }, true);
  window.addEventListener('pageshow', () => update());
  const start = () => {
    if (update()) return;
    if (!apiRequested && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      apiRequested = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) update(); });
    }
    if (++attempts < 80) setTimeout(start, 250);
  };
  start();
})();
